import { call, put, takeEvery } from 'redux-saga/effects';
import moment from 'moment';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item.regular_user,
      key: item.regular_user.uuid,
      creator: {
        uuid: item.regular_user.uuid,
        avatar_url: item.regular_user.avatar_url,
        avatar_params: item.regular_user.avatar_params,
        name: item.regular_user.name,
        social_accounts: item.regular_user.social_accounts,
        connection_id: item.id
      },
      links: item.lifetime_links,
      clicks: item.lifetime_clicks,
      sales: item.lifetime_gmv,
      last_link_shared: item.last_link_shared,
      campaigns: item.top_campaigns,
      groups: item.top_groups,
      connection_id: item.id,
      select: { id: item.regular_user.uuid, value: false },
      operations: item.regular_user
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getNewArrivals({ payload: { signal } }) {
  try {
    const last7Days = moment()
      .subtract(7, 'days')
      .startOf('day')
      .format();

    const { data } = yield call(fetch, {
      api: api.unmasking.connections.list,
      params: {
        page: 1,
        connected_since: last7Days,
        ordering: ['-created_at']
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getNewArrivalsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getNewArrivalsFailed,
      endpoint: api.unmasking.connections.list.url
    });
  }
}

export const getNewArrivalsSaga = takeEvery(types.GET_NEW_ARRIVALS_REQUEST, getNewArrivals);